import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import "../css/Header.css";

export default function Header() {
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const toggleDropdown = (name: string) =>
    setActiveDropdown((prev) => (prev === name ? null : name));
  const hideDropdown = () => setActiveDropdown(null);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  // Internal nav items (exclude external "Sister-Venue")
  const navItems = ["Reservations", "Gifting", "Menu", "Wine", "Experience", "Shop", "Events", "Contact"];

  return (
    <header className="py-4">
      <Link to="/">
        <img
          src="/images/maynooth_logo.png"
          alt="Ely Wine Bar Logo"
          height={300}
        />
      </Link>

      <nav
        className="nav justify-content-center my-3"
        style={{ gap: "12px" }} // ✅ ensures spacing between nav items
      >
        {navItems.map((item) => {
          if (item === "Reservations") {
            return (
              <div
                className="nav-item dropdown"
                key={item}
                ref={dropdownRef}
                onMouseLeave={hideDropdown}
              >
                <button
                  className={`nav-link text-dark wine-toggle ${
                    activeDropdown === item ? "active" : ""
                  }`}
                  onClick={() => toggleDropdown(item)}
                >
                  {item}
                </button>
                <ul
                  className={`dropdown-menu custom-dropdown ${
                    activeDropdown === item ? "show" : ""
                  }`}
                >
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://www.opentable.ie/booking/restref/availability?lang=en-IE&correlationId=8a580344-0250-4f19-9529-46622d12da90&restRef=176043&otSource=Restaurant%20website"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      Book Now
                    </a>
                  </li>
                </ul>
              </div>
            );
          }
        
        
          if (item === "Gifting") {
            return (
              <div
                className="nav-item dropdown"
                key={item}
                onMouseLeave={hideDropdown}
              >
                <button
                  type="button"
                  className={`nav-link text-dark wine-toggle ${
                    activeDropdown === item ? "active" : ""
                  }`}
                  onClick={() => toggleDropdown(item)}
                  aria-expanded={activeDropdown === item}
                >
                  Gifting
                </button>

                <ul
                  className={`dropdown-menu custom-dropdown ${
                    activeDropdown === item ? "show" : ""
                  }`}
                >
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://shop.elywinebar.ie/collections/gifting"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Gifting
                    </a>
                  </li>

                  <li>
                    <a
                      className="dropdown-item"
                      href="https://canva.link/ely-christmas-gifting-brochure"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Corporate Gifting
                    </a>
                  </li>
                </ul>
              </div>
            );
          }


         if (item === "Experience") {
          return (
            <a
              key={item}
              className="nav-link text-dark"
              href="https://shop.elywinebar.ie/collections/wine-tastings-at-ely-wine-store-maynooth"
              target="_blank"
              rel="noopener noreferrer"
            >
              Experience
            </a>
          );
        } 

          if (item === "Wine") {
            return (
              <div
                className="nav-item dropdown"
                key={item}
                ref={dropdownRef}
                onMouseLeave={hideDropdown}
              >
                <button
                  className={`nav-link text-dark wine-toggle ${
                    activeDropdown === item ? "active" : ""
                  }`}
                  onClick={() => toggleDropdown(item)}
                >
                  {item}
                </button>
                <ul
                  className={`dropdown-menu custom-dropdown ${
                    activeDropdown === item ? "show" : ""
                  }`}
                >
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/wine"
                      onClick={(e) => e.stopPropagation()}
                    >
                      Wine List
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/wine-tastings"
                      onClick={(e) => e.stopPropagation()}
                    >
                      Wine Tastings
                    </Link>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://shop.elywinebar.ie/collections/wine"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      Wine Retail
                    </a>
                  </li>
                </ul>
              </div>
            );
          }

          if (item === "Events") {
            return (
              <Link className="nav-link text-dark" to="/events" key={item}>
                {item}
              </Link>
            );
          }

          if (item === "Contact") {
            return (
               <a
              key={item}
              className="nav-link text-dark"
              href="https://form.jotform.com/212653008716048"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contact
            </a>
            );
          }

          if (item === "Shop") {
            return (
              <div
                className="nav-item dropdown"
                key={item}
                ref={dropdownRef}
                onMouseLeave={hideDropdown}
              >
                <button
                  className={`nav-link text-dark wine-toggle ${
                    activeDropdown === item ? "active" : ""
                  }`}
                  onClick={() => toggleDropdown(item)}
                >
                  {item}
                </button>
                <ul
                  className={`dropdown-menu custom-dropdown ${
                    activeDropdown === item ? "show" : ""
                  }`}
                >
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/vouchers"
                      onClick={(e) => e.stopPropagation()}
                    >
                      Vouchers
                    </Link>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://shop.elywinebar.ie/collections/gifting"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      Gifting
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="https://shop.elywinebar.ie/collections/tableware"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      Table & Glassware
                    </a>
                  </li>
                </ul>
              </div>
            );
          }

          // Default internal links
          return (
            <Link
              className="nav-link text-dark"
              to={`/${item.toLowerCase()}`}
              key={item}
            >
              {item}
            </Link>
          );
        })}

        {/* External Sister-Venue link */}
        <a
          className="nav-link text-dark"
          href="https://elywinebar-dublin.ie"
          target="_blank"
          rel="noopener noreferrer"
        >
          Sister-Venue
        </a>
      </nav>
    </header>
  );
}
